import { api } from "@/plugins/api";
import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

const getDefaultState = () => {
  return {
    demandeAdmission: {
      id: null,
      pp: null,
      creationDuContact: true,
      isNewDemandeAdmission: false,
      origineAdmission: { id: null },
      statutAdmission: { id: Vue.prototype.$catalogues.statutDemandeAdmission.candidatureNonFinalisee },
      notes: "",
      genererLaFacture: false,
      lectureSeule: false,
      motifsRenonciation: [],
      explicationsMotif: "",
    },
  };
};

const state = getDefaultState();

const getters = {
  GET_DEMANDEADMISSION: (state) => {
    return state.demandeAdmission;
  },
  GET_CONTACTID: (state) => {
    return state.demandeAdmission.pp;
  },
  GET_DEMANDEADMISSIONID: (state) => {
    return state.demandeAdmission.id;
  },
  isLectureSeule: (state) => {
    return state.demandeAdmission?.lectureSeule || false;
  },
};

const mutations = {
  SET_ID(state, id) {
    state.demandeAdmission.id = id;
  },
  SET_CONTACTID(state, id) {
    state.demandeAdmission.pp = id;
  },
  SET_DEMANDEADMISSION(state, dto) {
    state.demandeAdmission = { ...dto };
    state.demandeAdmission.sexe = { ...dto.sexe };
  },
  SET_ISNEWDEMANDEADMISSION(state, isNewDemandeAdmission) {
    state.demandeAdmission.isNewDemandeAdmission = isNewDemandeAdmission;
  },
  SET_GENERERFACTURE(state, value) {
    state.demandeAdmission.genererLaFacture = value;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
};

const actions = {
  async createDemandeAdmission({ commit }, pDemandeAdmissionDTO) {
    const response = await api.post(`demandesadmissions`, pDemandeAdmissionDTO);
    commit("SET_ID", response.data);
    commit("SET_ISNEWDEMANDEADMISSION", true);
  },
  async getLinkedContactEncryptedId({ commit }, encryptedId) {
    const response = await api.get(`demandesadmissions/${encryptedId}/contact`);
    commit("SET_CONTACTID", response.data ? response.data : {});
  },
  async updateDemandeAdmission({ commit }, pDemandeAdmissionDTO) {
    const response = await api.put(`demandesadmissions`, pDemandeAdmissionDTO);
    commit("SET_DEMANDEADMISSION", response.data ? response.data : {});
  },
  async fetchDemandeAdmission({ commit }, encryptedId) {
    const response = await api.get(`demandesadmissions/` + encryptedId);
    commit("SET_DEMANDEADMISSION", response.data ? response.data : {});
  },
  async getDemandeExistante({ commit }, payload) {
    const response = await api.get(`contacts/${payload.contactEncryptedId}/demandesadmissions`, { params: { origine: payload.origine.id } });
    commit("SET_ID", response.data ? response.data : null);
    return response.data;
  },
  async synchronisationInfosContact({ commit }) {
    const response = await api.put(`demandesadmissions/${state.demandeAdmission.id}/synchronisation-infos-contact`);
    return response;
  },
  envoiLien({ commit }) {
    return api.put(`demandesadmissions/${state.demandeAdmission.id}/envoilien`);
  },
  envoiConfirmation({ commit }) {
    return api.put(`demandesadmissions/${state.demandeAdmission.id}/envoiconfirmation`);
  },
  resetModuleState({ commit }) {
    commit("resetState");
  },
};

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions,
  //modules: {
  //  RenseignementsGeneraux
  //},
};